import React, { lazy, Suspense } from 'react';
import { Route, Switch, Redirect }   from 'react-router-dom';
import Loading from '../custom/Loading';

// Base
import MainWrapper  from './MainWrapper';

// ENV
import { CLIENT_EXPEDIENT } from '../constants/app'

// Log in / Register
const LogIn               = lazy(() => import('../containers/login'));
const Register            = lazy(() => import('../containers/register'));
const Landing             = lazy(() => import('../containers/landing'));
const Layout              = lazy(() => import('../containers/_layout'));
const OnBoardingLayout    = lazy(() => import('../containers/onBoardingLayout'));
const Main                = lazy(() => import('../containers/main'));
const Companies           = lazy(() => import('../containers/main/components/SelectCompanies'))
const CompanyAccount      = lazy(() => import('../containers/main/components/Account'))

// App Pages
const DashboardPage       = lazy(() => import('../containers/dashboard'));
const RemindersPage       = lazy(() => import('../containers/reminders'));
const CustomersPage       = lazy(() => import('../containers/customers'));
const InvoicesPage        = lazy(() => import('../containers/invoices'));
const ContractsPage       = lazy(() => import('../containers/contracts'));
const ContractPage        = lazy(() => import('../containers/contract'));
const ImportPage          = lazy(() => import('../containers/import'));
const InvoicePage         = lazy(() => import('../containers/invoice'));
const PaymentsPage        = lazy(() => import('../containers/payments'));
const CreateInvoicePage   = lazy(() => import('../containers/createInvoice'));
const CreateContractPage  = lazy(() => import('../containers/createContract'));
const EditContractPage    = lazy(() => import('../containers/editContract'));
const EditInvoicePage     = lazy(() => import('../containers/editInvoice'));
const CreateNotePage      = lazy(() => import('../containers/createNote'));
const CreditNotePage      = lazy(() => import('../containers/creditNote'));
const CustomerPage        = lazy(() => import('../containers/customer'));
const CustomerPageTwo     = lazy(() => import('../containers/customer/newIndex'));
const SubscriptionPage    = lazy(() => import('../containers/subscription'));
const CheckoutPage        = lazy(() => import('../containers/checkout'));
const OnBoardingPage      = lazy(() => import('../containers/onBoarding'));

const PaymentReconciliationPage = lazy(() => import('../containers/bank-reconciliation/payment-reconciliation'));

// Account Pages
const AccountPage   = lazy(() => import('../containers/account'));

// New Account Page
const ConfigurationPage = lazy(() => import('../containers/configuration'));

// Portal
const Portal         = lazy(() => import('../containers/portal'));
const PortalContract = lazy(() => import('../containers/portalContract'));
const PortalCheckout = lazy(() => import('../containers/portalCheckout'));

const Router = () => (
  <MainWrapper>
    <main>
      <Suspense fallback={ <Loading center /> }>
        <Switch>
          <Route exact path='/'       component={ Landing }/>
          <Route path='/portal'       component={ PortalApp }/>
          <Route path='/checkout'     component={ PortalApp }/>
          <Route path='/signup'       component={ Main }/>
          <Route path='/pricing'      component={ PricingLayout }/>
          <Route path='/login'        component={ Main }/>
          <Route path='/recovery'     component={ Main }/>
          <Route path='/companies'    component={ Companies }/>
          <Route path='/company'      component={ CompanyAccount }/>
          <Route path='/'             component={ AppLayout }/>
        </Switch>
      </Suspense>
    </main>
  </MainWrapper>
); // END Router

const AppLayout = () => {
  return (
    <div>
      <Layout/>
      <div className='container__wrap'>
        <Route path='/app'     component={ App }/>
        <Route path='/account' component={ Account }/>
      </div>
    </div>
  )
}// END AppLayout

const PortalApp = () => {
  return (
    <Switch>
      <Route path='/portal/:uuid'   component={ Portal } />
      <Route path='/checkout/:uuid' component={ PortalCheckout } />
      <Route path='/checkout'       component={ PortalContract } />
    </Switch>
  )
} // END PortalLayout

const PricingLayout = () => (
  <div>
    <OnBoardingLayout/>
    <div className='container__wrap container_pricing'>
      <Route path='/pricing/checkout' component={ CheckoutPage }/>
    </div>
  </div>
)

const App = () =>  (
  <Suspense fallback={ <Loading center /> }>
    <Switch>
      <Route path='/app/customers'             component={ CustomersPage }/>
      <Route path='/app/customer/:id'          component={ CLIENT_EXPEDIENT == 'true' ? CustomerPageTwo : CustomerPage }/>
      <Route path='/app/dashboard'             component={ DashboardPage }/>
      <Route path='/app/reminders'             component={ RemindersPage }/>
      <Route path='/app/invoices'              component={ InvoicesPage }/>
      <Route path='/app/contracts'             component={ ContractsPage }/>
      <Route path='/app/contract/detail/:uuid' component={ ContractPage }/>
      <Route path='/app/import/:type'          component={ ImportPage }/>
      <Route path='/app/invoice/detail/:uuid'  component={ InvoicePage }/>
      <Route path='/app/payments'              component={ PaymentsPage }/>
      <Route path='/app/invoice/create'        component={ CreateInvoicePage }/>
      <Route path='/app/invoice/emit/:uuid'    component={ CreateInvoicePage }/>
      <Route path='/app/contract/create'       component={ CreateContractPage }/>
      <Route path='/app/subscription'          component={ SubscriptionPage }/>
      <Route path='/app/checkout'              component={ CheckoutPage }/>
      <Route path='/app/onboarding'            component={ OnBoardingPage }/>
      <Route path='/app/note/create'           component={ CreateNotePage }/>
      <Route path='/app/note/detail/:uuid'     component={ CreditNotePage }/>
      <Route path='/app/contract/edit/:uuid'   component={ EditContractPage }/>
      <Route path='/app/invoice/edit/:uuid'    component={ EditInvoicePage }/>
      <Route path='/app/payment-reconciliation'   component={ PaymentReconciliationPage }/>
      <Redirect to={'/app/dashboard'} />
    </Switch>
  </Suspense>
);

const Account = () => (
  <Suspense fallback={ <Loading center /> }>
    <Switch>
      <Route path='/account/:page_name'   component={ ConfigurationPage }/>
      <Route path='/account/companies'    component={ ConfigurationPage }/>
      <Route path='/account/profile'      component={ ConfigurationPage }/>
      <Route path='/account/payments'     component={ ConfigurationPage }/>
      <Route path='/account/emails'       component={ ConfigurationPage }/>
      <Route path='/account/collection'   component={ ConfigurationPage }/>
      <Route path='/account/integrations' component={ ConfigurationPage }/>
      <Route path='/account/users'        component={ ConfigurationPage }/>
      <Route path='/account/subscription' component={ ConfigurationPage }/>
      <Route path='/account/bank_connections' component={ ConfigurationPage }/>
      <Redirect to={'/app/dashboard'} />
    </Switch>
  </Suspense>
);

export default Router;



// WEBPACK FOOTER //
// ./src/app/Router.js